export default __webpack_public_path__ + "static/media/vdm-catalog.b3eace1d.pdf";